'use strict'

paginationFooterTemplate = require '../../../pagination/footer.html.mustache'

module.exports = class HomePaginationView extends Backbone.View
  events:
    'click .pagination a': 'paginationClickHandler'

  initialize: ->
    @presentedHash = null

  render: (opts = {}) ->
    if opts.presentedHash then @presentedHash = opts.presentedHash

    @$el.html @toHtml()

  toHtml: ->
    paginationFooterTemplate.render @presentedHash

  paginationClickHandler: (event) =>
    event.preventDefault()
    @trigger 'click:paginationLink', event
